/**
 * @file Host utils for form compliance.
 */
import { type DataGouvAddressesResponse } from "@oefr/services/data-gouv-addresses"

export function formatDataGouvAddresses(response: DataGouvAddressesResponse) {
    return response.features.map(({ properties }) => ({
        fullAddress: properties.label,
        addrCityLabel: properties.city,
        addrStreetLabel: properties.street ?? "",
        addrNumStreet: properties.name,
        addrPostCode: properties.postcode ?? "",
    }))
}
